module.exports = __webpack_public_path__ + "img/logo.a2ff29d8.png";